import styled from 'styled-components';

import { Button } from '../Button/Button';

const themes = {
  1: {
    colorBkg: 'var(--color-black)',
    colorTitle: 'var(--color-white)',
    colorDescription: 'var(--color-white)',
    colorOnlyDescription: 'var(--color-white)',
    buttonTheme: '5',
  },
  2: {
    colorBkg: 'var(--color-grey-16)',
    colorTitle: 'var(--color-black)',
    colorDescription: 'var(--color-black)',
    colorOnlyDescription: 'var(--color-black)',
    buttonTheme: '1',
  },
};

const sizes = {
  m: {
    height: '80px',
  },
};

export const Container = styled.div`
  --color-bkg: ${(p) => (themes[p.theme] || themes['1']).colorBkg};
  --color-title: ${(p) => (themes[p.theme] || themes['1']).colorTitle};
  --color-description: ${(p) => (themes[p.theme] || themes['1']).colorDescription};
  --color-only-description: ${(p) => (themes[p.theme] || themes['1']).colorOnlyDescription};
  --height: ${(p) => (sizes[p.size] || sizes['m']).height};

  min-height: var(--height);
  max-height: var(--height);
  display: flex;
  align-items: center;
  background-color: var(--color-bkg);
  border-radius: 16px;
  padding: 0 16px;
  gap: 16px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px 0;
`;

export const Title = styled.div`
  color: var(--color-title);

  font: var(--font-heading-large-24_2);
`;

export const Description = styled.div`
  color: var(--color-description);

  font: var(--font-regular-15);
`;

export const OnlyDescription = styled.div`
  color: var(--color-only-description);

  font: var(--font-heading-large-20_3);
`;

export const StyledButton = styled(Button).attrs((p) => ({
  theme: p.buttonTheme ? themes[p.buttonTheme].buttonTheme : themes['1'].buttonTheme,
}))`
  margin-left: ${(p) => (p.imgPosition === 'right' ? '0' : 'auto')};
`;

export const LeftImgWrapper = styled.span`
  display: flex;
  align-self: self-end;
`;

export const RightImgWrapper = styled(LeftImgWrapper)`
  margin-left: auto;
`;
